import type React from "react";

// Clarity masking attributes (design section 5; applied by PR D). Spread on
// JSX: <span {...CLARITY_MASK}>. Inert for the user (no CSS, no JS, no
// call) - only Clarity's recorder reads them, so they are deliberately NOT
// behind a flag: a forgotten flag in prod would mean personal data is
// recorded again. One import path = greppable (the literal "data-clarity-"
// exists in this file only, pinned by clarityAttrs.coverage.test.tsx), and
// can be turned into {} here should flagging ever be wanted.
//
// Rules (design 5.1): MASK on the SMALLEST element that holds names,
// addresses, contact info or free text; UNMASK only on RENDERED non-personal
// numbers (dimensions, quantities, stock, SKU/MUL, order numbers) - never on
// prices, tracking numbers, inputs or dropdowns (inputs cannot be unmasked
// in any mode). MUI Tooltip renders in a portal: pass
// componentsProps={{ tooltip: CLARITY_MASK }} next to a masked trigger.
export const CLARITY_MASK = { "data-clarity-mask": "True" } as const;
export const CLARITY_UNMASK = { "data-clarity-unmask": "True" } as const;

// MUI Tooltip renders its bubble in a portal, so an attribute on the trigger
// does not reach it: pass this as componentsProps next to a masked trigger.
// The slot is typed as a weak HTMLAttributes object (a data-* key alone
// would not be assignable), hence the one widening cast here.
export const CLARITY_MASK_TOOLTIP = {
  tooltip: CLARITY_MASK as unknown as React.HTMLAttributes<HTMLDivElement>,
};

// Logo titles are free text the user typed only for text, name and number
// logos (a person's name on a shirt is a title); image/symbol logo titles
// stay visible (design 5.2, closes Q5).
const TEXT_BASED_LOGO_TYPES = ["TextLogo", "NameLogo", "NumberLogo"];

export function isTextBasedLogoType(
  logoType: string | undefined | null,
): boolean {
  return !!logoType && TEXT_BASED_LOGO_TYPES.includes(logoType);
}

export function maskIfTextLogo(
  logoType: string | undefined | null,
): typeof CLARITY_MASK | Record<string, never> {
  return isTextBasedLogoType(logoType) ? CLARITY_MASK : {};
}
